import React from 'react';
import './finalresult.css';

function FinalResult({ result, pdfref }) {
  const sectionTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '0.75rem',
    borderBottom: '2px solid #e5e7eb',
    paddingBottom: '0.25rem'
  };

  const chipStyle = (bgColor, textColor) => ({
    padding: '0.5rem 1rem',
    borderRadius: '9999px',
    fontWeight: '500',
    fontSize: '0.875rem',
    backgroundColor: bgColor,
    color: textColor,
    border: '1px solid #e5e7eb'
  });

  const boxStyle = {
    marginTop: '1rem',
    padding: '1rem',
    border: '1px solid #e5e7eb',
    borderRadius: '0.5rem',
    backgroundColor: '#f9fafb',
    color: '#4b5563',
    fontSize: '1rem',
    lineHeight: '1.5'
  };

  return (
    <div
      ref={pdfref}
      style={{
        maxWidth: '64rem',
        margin: '2rem auto',
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '1rem',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)'
      }}
    >
      <h1 style={{ fontSize: '2rem', fontWeight: '700', textAlign: 'center', color: '#111827' }}>
        Technology Stack Summary
      </h1>
      <p style={{ textAlign: 'center', color: '#6b7280', marginTop: '0.5rem' }}>
        A comprehensive overview of the selected technologies for the smart home automation application.
      </p>

      {/* Summary Section */}
       <section style={{ marginTop: '1.5rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#374151' }}>Summary</h2>
          <p
            style={{
              marginTop: '0.5rem',
              padding: '1rem',
              border: '1px solid #e5e7eb',
              borderRadius: '0.375rem',
              backgroundColor: '#f9fafb',
              color: '#4b5563'
            }}
          >
            {result?.summary?.map((e) => (
              <li>{e}</li>
            ))}
          </p>
        </section>

      {/* Technology Sections */}
      {[
  {
    title: 'Programming Languages',
    items: result?.suggestions?.technology_stack?.programming_languages,
    bg: '#e0f2fe',
    color: '#0369a1'
  },
  {
    title: 'Frameworks',
    items: result?.suggestions?.technology_stack?.frameworks,
    bg: '#ede9fe',
    color: '#7c3aed'
  },
  {
    title: 'Databases',
    items: result?.suggestions?.technology_stack?.databases,
    bg: '#d1fae5',
    color: '#047857'
  },
  {
    title: 'Hosting Platforms',
    items: result?.suggestions?.technology_stack?.hosting_platforms,
    bg: '#ffe4e6',
    color: '#be123c'
  },
  {
    title: 'Tools',
    items: result?.suggestions?.tools,
    bg: '#f3f4f6',
    color: '#374151'
  }
].map((section, idx) =>
  section.items?.length ? (
    <section
      key={idx}
      style={{
        marginTop: '2rem',
        padding: '1.5rem',
        border: '1px solid #e5e7eb',
        borderRadius: '0.75rem',
        backgroundColor: '#ffffff',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center'
      }}
    >
      <h2
        style={{
          fontSize: '1.5rem',
          fontWeight: '600',
          color: '#111827',
          marginBottom: '1rem',
          borderBottom: '2px solid #e5e7eb',
          paddingBottom: '0.5rem',
          display: 'inline-block'
        }}
      >
        {section.title}
      </h2>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0.75rem',
          justifyContent: 'center',
          marginTop: '1rem'
        }}
      >
        {section.items.map((item) => (
          <span
            key={item}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: section.bg,
              color: section.color,
              fontWeight: 500,
              borderRadius: '9999px',
              border: `1px solid ${section.color}30`,
              fontSize: '0.9rem',
              transition: 'all 0.2s ease-in-out',
              display: 'inline-block'
            }}
          >
            {item}
          </span>
        ))}
      </div>
    </section>
  ) : null
)}


      {/* Other Considerations */}
      {result?.suggestions?.other_considerations && (
        <section style={{ marginTop: '2rem' }}>
          <h2 style={sectionTitleStyle}>Other Considerations</h2>
          <p style={boxStyle}>{result.suggestions.other_considerations}</p>
        </section>
      )}

      {/* Rationale */}
      {result?.rationale && (
        <section style={{ marginTop: '2rem' }}>
          <h2 style={sectionTitleStyle}>Rationale</h2>
          <p style={boxStyle}>{result.rationale}</p>
        </section>
      )}

      {/* Footer Note */}
      <section style={{ marginTop: '2rem', textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
        *These AI-generated results provide valuable insights. For a more tailored analysis, feel free to connect with us.
      </section>
    </div>
  );
}

export default FinalResult;
